import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../Context/ConfigContext';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishList, removeWishListItem } from '../Redux/features/WishList/WishlistSlice';
import { addToCart } from '../Redux/features/Cart/CartSlice';
import { toast, ToastContainer } from 'react-toastify';
import "../Styles/filter.css"
import { formatSlug } from '../Utils/Helper';
import GlobalCards from '../Utils/GlobalCards';

const LIMIT_PRODUCTS = [10, 20, 30]
const LIMIT_STORE = ["Featured", "High to Low", "Low to High"]

const AllProductsList = () => {
    const { apiURL, apiHeaderJson, currencyValue } = useContext(ConfigContext);
    const [data, setData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, total_pages: 1, next: false, prev: false });
    const [expandedId, setExpandedId] = useState(null);
    const [productLimit, setProductLimit] = useState(10);
    const [storeByLimit, setStoreByLimit] = useState("Featured");
    const wishList = useSelector(state => state.Wishlist)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const path = useLocation();
    const category_id = path.pathname.split('=')[1];

    const GetProducts = async (page = 1) => {
        if (category_id) {
            const response = await axios.get(`${apiURL}Home/GetProductsByCategory`, {
                params: {
                    limit: productLimit,
                    page: page,
                    category_id: category_id,
                    sort_by: storeByLimit,
                },
                headers: apiHeaderJson
            })

            setCategoryData(response.data)
            setData(response.data?.data?.data);
            setPagination({
                page: response.data.data.page,
                total_pages: response.data.data.total_pages,
                next: response.data.data.next,
                prev: response.data.data.prev
            });
        } else {
            const response = await axios.get(`${apiURL}Home/GetAllProducts?limit=${productLimit}&sort_by=${storeByLimit}`, { headers: apiHeaderJson });
            setData(response.data?.data?.data);
        }
    };

    const toggleExpansion = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const handleAddToCart = (product) => {
        const newProduct = { ...product, selected_currency: currencyValue }
        dispatch(addToCart(newProduct))
        toast.success(`${product.product_title} Added`, {
            position: "bottom-center",
        })
    }
    const CheckWishList = (product_id) => {
        return wishList.some((item) => item.product_id === product_id);
    }

    const handleProductDetails = (product) => {
        if (product) {
            navigate(`/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`)
        }
    }

    const handleSelectLimit = (limit) => {
        setProductLimit(limit)
    }

    const handleSortByLimit = (filter) => {
        setStoreByLimit(filter)
    }


    useEffect(() => {
        GetProducts(pagination.page);
        document.title = 'StoneSkill'
    }, [productLimit, pagination.page]);

    const handlePageChange = (newPage) => {
        setPagination((prev) => ({ ...prev, page: newPage }));
    };

    useEffect(() => {
        GetProducts();
    }, [productLimit, storeByLimit, category_id]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <>
            <ToastContainer />
            <div className="page-header mt-30 mb-50">
                <div className="container">
                    <div className="archive-header">
                        <div className="row align-items-center">
                            <div className="col-xl-4">
                                {category_id ?
                                    <>
                                        <h1 className="mb-15">{categoryData.category_data}</h1>
                                        <div className="breadcrumb">
                                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                                            <span /> Shop <span /> {categoryData.category_data}
                                        </div>
                                    </>
                                    :
                                    <>
                                        <h1 className="mb-15">All Products</h1>
                                        <div className="breadcrumb">
                                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                                            <span /> All Products <span />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-4-6'>
                        <div className='container'>
                            <div className="shop-product-fillter">
                                <div className="totall-product">
                                    <p>We found <strong className="text-brand">{data.length}</strong> items for you!</p>
                                </div>
                                <div className="sort-by-product-area">
                                    <div className="sort-by-cover mr-10">
                                        <div className="sort-by-product-wrap">
                                            <div className="sort-by">
                                                <span>
                                                    <i className="fi-rs-apps" />
                                                    Show :
                                                </span>
                                            </div>
                                            <div className="sort-by-dropdown-wrap">
                                                <span> {productLimit} <i className="fi-rs-angle-small-down" /></span>
                                            </div>
                                        </div>
                                        <div className="sort-by-dropdown">
                                            <ul>
                                                {LIMIT_PRODUCTS.map((item) => (
                                                    <li onClick={() => handleSelectLimit(item)}><a className={productLimit === item && "active"}>{item}</a></li>
                                                ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="sort-by-cover">
                                        <div className="sort-by-product-wrap">
                                            <div className="sort-by">
                                                <span><i className="fi-rs-apps-sort" />Sort by : </span>
                                            </div>
                                            <div className="sort-by-dropdown-wrap">
                                                <span>{storeByLimit}<i className="fi-rs-angle-small-down" /></span>
                                            </div>
                                        </div>
                                        <div className="sort-by-dropdown">
                                            <ul>
                                                {LIMIT_STORE.map((filter) => {
                                                    return (
                                                        <li onClick={() => handleSortByLimit(filter)}><a className={storeByLimit === filter && "active"}>{filter}</a></li>
                                                    )
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="product-tabs section-padding position-relative">
                            <div className="container">
                                <div className="tab-content" id="myTabContent">
                                    <div className="tab-pane fade show active" id="tab-one" role="tabpanel" aria-labelledby="tab-one">
                                        <div className="row product-grid-4">
                                            {data.map((item, i) => (
                                                <GlobalCards
                                                    item={item}
                                                    handleProductDetails={() => handleProductDetails(item)}
                                                    handleAddToCart={handleAddToCart}
                                                    CheckWishList={CheckWishList(item?.product_id)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section >
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="pagination-area" style={{ marginBottom: '30px' }}>
                                <nav>
                                    <ul className="pagination justify-content-start">
                                        <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                                            <a className="page-link" onClick={() => handlePageChange(pagination.page - 1)}>
                                                <i className="fi-rs-arrow-small-left" />
                                            </a>
                                        </li>

                                        <li className={`page-item ${pagination.page === 1 ? 'active' : ''}`}>
                                            <a className="page-link" onClick={() => handlePageChange(1)}>1</a>
                                        </li>

                                        {pagination.page > 3 && pagination.total_pages > 5 && (
                                            <li className="page-item disabled">
                                                <span className="page-link">...</span>
                                            </li>
                                        )}

                                        {Array.from({ length: pagination.total_pages }, (_, i) => i + 1)
                                            .filter(page =>
                                                page === pagination.page ||
                                                (page >= pagination.page - 1 && page <= pagination.page + 1)
                                            )
                                            .map(page => (
                                                page !== 1 && page !== pagination.total_pages && (
                                                    <li key={page} className={`page-item ${pagination.page === page ? 'active' : ''}`}>
                                                        <a className="page-link" onClick={() => handlePageChange(page)}>{page}</a>
                                                    </li>
                                                )))
                                        }

                                        {pagination.page < pagination.total_pages - 2 && pagination.total_pages > 5 && (
                                            <li className="page-item disabled">
                                                <span className="page-link">...</span>
                                            </li>
                                        )}

                                        {pagination.total_pages > 1 && (
                                            <li className={`page-item ${pagination.page === pagination.total_pages ? 'active' : ''}`}>
                                                <a className="page-link" onClick={() => handlePageChange(pagination.total_pages)}>{pagination.total_pages}</a>
                                            </li>
                                        )}

                                        <li className={`page-item ${pagination.page === pagination.total_pages ? 'disabled' : ''}`}>
                                            <a className="page-link" onClick={() => handlePageChange(pagination.page + 1)}>
                                                <i className="fi-rs-arrow-small-right" />
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllProductsList;